<template>
  <div class="antv-chart-mini">
    <div class="chart-wrapper" :style="{ height: 46 }">
      <v-chart :forceFit="true" :height="height" :data="dataSource" :scale="scale" :padding="[36, 5, 18, 5]">
        <v-tooltip/>
        <v-bar position="dateKey*quantity" color="channel" :adjust="adjust"/>
      </v-chart>
    </div>
  </div>
</template>

<script>

const scale = [{
  dataKey: 'dateKey',
  type: 'timeCat'
}]
export default {
  props: {
    height: {
      default: 130
    },
    dataSource: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      adjust: [{
        type: 'dodge',
        marginRatio: 1 / 32
      }],
      scale
    }
  },
  mounted () {
    console.log('channel card bar data', this.dataSource)
  }
}
</script>

<style lang="less" scoped>
  @import "chart";
</style>



// WEBPACK FOOTER //
// src/components/Charts/MiniBar.vue